import { z } from 'zod';
export const userRole = z.enum(['owner', 'admin', 'staff', 'viewer']);
export const updateUserRoleInput = z.object({
    role: userRole,
});
